import CountryDescription from "./CountryDescription";

export default CountryDescription;
